
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { analyticsService } from '../services/analyticsService';
import { useLocation } from 'react-router-dom';

export const useAnalytics = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Set user ID when user is available
  useEffect(() => {
    if (user?.id) {
      analyticsService.setUserId(user.id);
    }
  }, [user?.id]);

  // Track page views
  useEffect(() => {
    analyticsService.trackPageView(location.pathname, {
      search: location.search,
      hash: location.hash
    });
  }, [location]);

  return {
    trackEvent: analyticsService.trackEvent.bind(analyticsService),
    trackInteraction: analyticsService.trackInteraction.bind(analyticsService),
    trackError: analyticsService.trackError.bind(analyticsService),
    trackPerformance: analyticsService.trackPerformance.bind(analyticsService)
  };
};
